import React, { useState, useEffect } from "react";
import axios from "axios";
import VisaAPIconfig from "../../Common/Configurations/VisaAPIConfig";
import { handleError } from "../../Common/Layout/CustomAlerts";
import moment from "moment";
import { useNavigate, useParams } from "react-router-dom";
import LayoutHeader from "../../Common/Layout/Header";

const VisaHistory = () => {
  const [visaHistory, setVisaHistory] = useState([]);
  const [loading, setLoading] = useState(true);
  const { visaRequestId } = useParams();
  const navigate = useNavigate();

  const fetchVisaHistory = async () => {
    try {
      const response = await axios.get(
        `${VisaAPIconfig.APIACTIVATEURL}${VisaAPIconfig.GETVISAHISTORY}?id=${visaRequestId}`,
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("userToken"),
          },
        }
      );
      if (response.data.statusCode === 200) {
        setVisaHistory(response.data.data);
      } else {
        handleError("Failed to fetch visa history");
      }
    } catch (error) {
      handleError(error.message);
    } finally {
      setLoading(false);
    }
  };

  // Fetch data on component mount
  useEffect(() => {
    fetchVisaHistory();
  }, [visaRequestId]);

  // Render visa history
  return (
    <div id="layout-wrapper">
      <LayoutHeader></LayoutHeader>
      <div className="main-content">
        <div className="page-content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-12">
                <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                  <h4 className="mb-sm-0">Visa Status History</h4>
                  <button
                    className="btn btn-secondary"
                    onClick={() => navigate(-1)}
                  >
                    Back
                  </button>
                </div>
              </div>
            </div>
            <div className="card">
              <div className="card-body">
                {loading ? (
                  <p>Loading history...</p>
                ) : visaHistory.length > 0 ? (
                  <div className="table-responsive">
                    <table className="table table-bordered">
                      <thead>
                        <tr>
                          <th>Status</th>
                          <th>Date</th>
                        </tr>
                      </thead>
                      <tbody>
                        {visaHistory.map((history) => (
                          <tr key={history.visaHistoryId}>
                            <td>{history.status}</td>
                            <td>
                              {moment(history.createdDate).format(
                                "Do MMM YYYY, h:mm a"
                              )}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                ) : (
                  <p>No history available.</p>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VisaHistory;
